export default __webpack_public_path__ + "static/media/united-cricket.b05f76bd.png";